import * as styles from './SelectValueItem.module.css'

function SelectValueItem({ Component, ...restProps }) {
  return (
    <div className={styles.SelectValueItem}>
      <Component {...restProps} />
    </div>
  )
}

export default SelectValueItem
